module.exports = __webpack_public_path__ + "img/tabLeft.093e6f1f.png";